import React, { useState, useEffect, useRef} from "react";
import { MessageImageName, MessageImages } from "../../../config/appConstants";
import { MessageSender } from "src/shared/types/src";
import { ConfirmationModal, ProfileImageView } from "src/app/components";

export type MessageDetailCardPropsType = {
  message: {
    id: number;
    subject: string;
    message: string;
    createdAt: string;
    createdAtHuman?: string
    sentBy?: MessageSender;
    photo?: string;
  }
};

const MessageDetailCard: React.FC<MessageDetailCardPropsType> = ({ message }) => {

  const messageRef = useRef<HTMLDivElement | null>(null);
  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const [url, setUrl] = useState<string>('');

  useEffect(() => {
    const handleLinkClick = (e: MouseEvent) => {
      const anchor = (e.target as HTMLElement).closest('a');
      if (anchor && messageRef.current?.contains(anchor)) {
        e.preventDefault();
        const link = anchor?.getAttribute('href') || '';
        if(link){
          setUrl(link);
          toggleConfirmationModal();
        }
      }
    };

    const container = messageRef.current;
    container?.addEventListener('click', handleLinkClick);

    return () => {
      container?.removeEventListener('click', handleLinkClick);
    };
  }, []);

  const toggleConfirmationModal = () => setConfirmationModal(!confirmationModal);

  const handleConfirmation = () => {
    if(url){
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.click();
    }
    toggleConfirmationModal();
  }

  return (
    <>
      <div className="message-detail-card">
        <div className="message-detail-card-header">
          <div className="message-detail-card-img">
            {message?.photo ? (
              <ProfileImageView
                name={message.sentBy?.name}
                imageUrl={message.photo}
              />
            ) : (
              <div className="avatar-icon">
                <img
                  src={MessageImages.get(MessageImageName.mail)}
                  alt="mail-icon"
                />
              </div>
            )}
          </div>
          <div className="message-detail-card-content">
            <div className="message-detail-card-title">{message?.subject}</div>
            <div className="message-detail-card-date">{message?.createdAtHuman || message?.createdAt}</div>
          </div>
        </div>
        {message?.message && (
          <div 
            ref={messageRef}
            dangerouslySetInnerHTML={{ __html: message.message }} 
            className="message-detail-card-message"
          >
          </div>
        )}
      </div>
      {confirmationModal && <ConfirmationModal
        isModal={confirmationModal}
        toggleModal={toggleConfirmationModal}
        confirmationText={<p className='pd-y-30'>This will redirect you to an external link</p>}
        handleConfirmation={handleConfirmation}
        popupMinHeight={'auto'}
        modalHeader={'Confirm'}
        primaryBtnText={'Continue'}
        secondaryBtnText={'Cancel'}
      />}
    </>
  );
}

export default MessageDetailCard;